export enum Department{
    Tech,
    Ops,
    Sys
}